import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { FEATURES } from "../../lib/content";
import { MaskLine, SectionLabel } from "./Reveal";

const toPascal = (s) =>
  s.split("-").map((w) => w[0].toUpperCase() + w.slice(1)).join("");

export default function Features() {
  return (
    <section data-testid="features-section" className="bg-white py-24 lg:py-32 border-y border-ink/10">
      <div className="max-w-7xl mx-auto px-6">
        <SectionLabel>Features</SectionLabel>
        <h2 className="font-heading font-extrabold tracking-tight text-ink text-4xl sm:text-5xl lg:text-6xl leading-[1] mb-14">
          <MaskLine>Everything you need</MaskLine>
          <MaskLine delay={0.1}>to <span className="text-flame">score better.</span></MaskLine>
        </h2>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-ink/10 border border-ink/10">
          {FEATURES.map((f, i) => {
            const Icon = Icons[toPascal(f.icon)] || Icons.Star;
            return (
              <motion.div
                key={f.t}
                data-testid={`feature-${i}`}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-8%" }}
                transition={{ duration: 0.5, delay: (i % 3) * 0.08 }}
                className="group bg-white p-8 hover:bg-paper transition-colors duration-300"
              >
                <span className="inline-grid place-items-center h-12 w-12 rounded-lg bg-ink text-white group-hover:bg-flame transition-colors duration-300">
                  <Icon className="h-6 w-6" />
                </span>
                <h3 className="mt-5 font-heading font-bold text-xl text-ink tracking-tight">{f.t}</h3>
                <p className="mt-2 text-ink/60 text-sm leading-relaxed">{f.d}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
